import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class SiteMobileMenu extends Component() {
		events() {
			this.$EE.on("SiteHamburger:enable", () => this.open());
			this.$EE.on("SiteHamburger:disable", () => this.close());
			this.$EE.on("SiteHeader:focus-out-hambuger", () =>
				this.focusLast()
			);
		}

		mounted() {
			this.circles = this.el.querySelectorAll(
				".c-site-mobile-menu__ripple .c-ripple__circle"
			);

			this.language = this.el.querySelector(
				".c-site-mobile-menu__language .c-language__trigger"
			);

			this.focusEls = [...this.el.querySelectorAll(".c-site-nav__link")];
		}

		animations() {
			gsap.set(this.circles, { scale: 0, transformOrigin: "50% 50%" });

			this.anim = gsap.timeline();

			this.anim.to(
				this.focusEls,
				{
					y: 0,
					ease: "expo.out",
					duration: 0.8,
					stagger: 0.08,
				},
				0
			);

			this.anim.to(
				this.circles,
				{
					scale: 1,
					ease: "back.out",
					duration: 0.5,
					stagger: 0.04,
				},
				0
			);
		}

		open() {
			this.el.classList.add("is-open");
			this.anim.seek(0);
			this.anim.play();
		}

		close() {
			this.el.classList.remove("is-open");
			this.anim.reverse();
		}

		onKeydown(e) {
			if (!this.$Store.isSiteMobileNavOpen) {
				return;
			}

			const isTab = e.key === "Tab" || e.keyCode === 9;
			const isShift = e.shiftKey;

			if (!isTab) {
				return;
			}

			const focusedEl = document.activeElement;
			const firstEl = this.focusEls[0];
			const lastEl = this.focusEls[this.focusEls.length - 1];

			if (focusedEl === firstEl && isShift) {
				this.$EE.emit("SiteMobileMenu:focus-first");
				e.preventDefault();
			}

			if (focusedEl === lastEl && !isShift) {
				this.language.focus();
				e.preventDefault();
			}

			if (focusedEl === this.language && !isShift) {
				this.$EE.emit("SiteMobileMenu:focus-last");
				e.preventDefault();
			}
		}

		focusLast() {
			this.language.focus();
		}
	};
